import styled from 'styled-components';

const StyledFeedContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export {
  StyledFeedContainer,
};
